module.exports = "<!-- ko if: hasIcon -->\n<svg class=\"sv-svg-icon\" data-bind=\"css: css\" role=\"img\"><use></use></svg>\n<!-- /ko -->\n";